import Moment from 'moment-timezone';
import moment from "moment";
import { saveAs } from 'file-saver';
import JsZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import React, { Component } from 'react';
import { CSVLink } from 'react-csv';
import ReactDataGrid from 'react-data-grid';
import MathJax from '../component/react-mathjax-preview';
import {
  Button, DataTable, DialogContainer, TableBody,
  TableColumn, TableHeader, FontIcon,
  LinearProgress, List,
  ListItem, 
  TableRow, Toolbar
} from 'react-md';
import { NotificationManager } from 'react-notifications';
import ApiRequestService from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';
import '../css/mediaCss.css';
import styles from '../css/styles.css.js';
import Properties from '../component/Properties';
import { AppProperties } from '../common/function';
import TextEditor from '../component/TextEditor.js';



function roundToX(num, X) {
  return +(Math.round(num + "e+"+X)  + "e-"+X);
}


const AnswerTextFormatter =  (props) => {
      if (props.isScrolling) {
        return <div>is scrolling</div>;
      }
      return <div><MathJax math={props.value}/></div>
}

const MQTTableHeaders = (props) => {
//  const columnCount = 1+Object.keys(props.questions).length;
  //const columnWidth = (100/columnCount) + '%';
  return  <TableRow>
            <TableColumn style={{width:"auto",textAlign:"center"}} className='mqt-quiz-score-table-th'><span>Assignment Name</span></TableColumn>
            <TableColumn style={{width:"auto",textAlign:"center"}} className='mqt-quiz-score-table-th'><span>User ID</span></TableColumn>
            {/* <TableColumn style={{width:"auto",textAlign:"center"}} className='mqt-quiz-score-table-th'><span>ID</span></TableColumn> */}
            <TableColumn style={{width:"auto",textAlign:"center"}} className='mqt-quiz-score-table-th'><span>SF ID</span></TableColumn>
            <TableColumn style={{width:"auto",textAlign:"center"}} className='mqt-quiz-score-table-th'><span>Start Date Time</span></TableColumn>
            <TableColumn style={{width:"auto",textAlign:"center"}} className='mqt-quiz-score-table-th'><span>End Date Time</span></TableColumn>
            {/* <TableColumn style={{width:"auto",textAlign:"center"}} className='mqt-quiz-score-table-th'><span>Completion Date</span></TableColumn> */}

            {
              Object.keys(props.questions).map((questionName,i)=>{
                return <TableColumn style={{width:"auto",textAlign:"center"}} key={i} className='mqt-quiz-score-table-th'><span>
                  <MathJax  math={props.questions[questionName].value}/></span></TableColumn>
              })
            }
          </TableRow>
}

const MQTTable =(props) =>{
  const appProperties = AppProperties();
  const {mqtQuestion} = props;
  let { nonGradedQuestions, nonGradedMQTQuestions } = props;
  
  let questions = mqtQuestion.mqt_options.mqt_questions
  var csvMqtQuestionsHeaders = [{ label: 'Assignment Name', key: 'quizName' }, { label: 'User ID', key: 'userID' },
  // { label: 'ID', key: 'OSUID' },
  {  label: 'SF ID', key: 'SFID'},
  { label: 'Section Name', key: 'section_name' },{ label: 'Subsection Name', key: 'subsection_name' },{ label: 'Start Date Time', key: 'question_start_time' }, {label: 'End Date Time', key: 'question_end_time' }];
  var csvMqtQuestions=[];
  Object.keys(questions).forEach((questionName,i)=>{
    let content   =  questions[questionName].value.replace(/<[^>]+>/g, '');
    
   csvMqtQuestionsHeaders.push({ label: content, key: 'Q_'+i});
   console.debug("content:",content,questionName)
   console.debug( questions[questionName].value)
  })

  mqtQuestion.user_choices.forEach((choice,i)=>{
    const answers = JSON.parse(choice.answers);
    
    let tempData = {}
    tempData.quizName = props.quizName
    tempData.userID = choice.userID
    // tempData.OSUID = choice.OSUID
     tempData.SFID  = choice.SFID
    tempData.section_name = choice.section_name
    tempData.subsection_name = choice.subsection_name
    if(userCompletionDateHashMap !== null && userCompletionDateHashMap[choice.userID] !== null){
      tempData.completionDate = userCompletionDateHashMap[choice.userID]
    }else{
      tempData.completionDate = ""
    }
    tempData.question_start_time = choice.question_start_time;
    tempData.question_end_time = choice.question_end_time;
    Object.values(answers).forEach((answerchoices,j)=>{
      let tempAnswer = answerchoices.map(val=>{return parseInt(val.charAt(0),10);}).join()
      tempData['Q_'+j]=tempAnswer
    })
    csvMqtQuestions.push(tempData)
  })
    console.debug(csvMqtQuestionsHeaders,csvMqtQuestions)
  //let csvMqtQuestions = 
  let currentTime = Moment.tz(Date(), appProperties.currentUserData.timeZone || "America/New_York");
  let downloadMQTCSV = (
    <div style={{textAlign: "right"}}>
      <CSVLink
      id="csv-download-link-popup"
        data={csvMqtQuestions}
        headers={csvMqtQuestionsHeaders}
        filename={
          'MQT Question'+
          '_'+
          mqtQuestion.questionText+
          '_' +
          currentTime.format()+
          '.csv'
        }
      >
        
          <Button primary swapTheming raised className="buttonColour">
            Download CSV
          </Button>
        
      </CSVLink>
    </div>
  ); 

  return <div>
         <div>
            <p  style={{fontSize:'medium',width:"50%"}} className='md-title md-title--toolbar'>
              Question Name: {mqtQuestion.questionText} 
            </p>
            {downloadMQTCSV} 
            </div>
            <br/>
          <DataTable plain>
            <TableHeader>
                <MQTTableHeaders questions={mqtQuestion.mqt_options.mqt_questions}/>
            </TableHeader>
            <TableBody>
              {mqtQuestion.user_choices.map((choice,i)=>{
                const answers = JSON.parse(choice.answers);
                const answer_header = mqtQuestion.mqt_options.mqt_answer_header;
                return  <TableRow  key={i} >
                          <TableColumn className='mqtquiz-score-table-td react-grid-Cell__value' 
                          style={{paddingRight:"0px"}}>{props.quizName}</TableColumn>
                          <TableColumn className='mqtquiz-score-table-td react-grid-Cell__value' 
                          style={{paddingRight:"0px"}}>{choice.userID}</TableColumn>
                          {/* <TableColumn className='mqtquiz-score-table-td react-grid-Cell__value' 
                          style={{paddingRight:"0px"}}>{choice.OSUID}</TableColumn> */}
                           <TableColumn className='mqtquiz-score-table-td react-grid-Cell__value' 
                          style={{paddingRight:"0px"}}>{choice.SFID}</TableColumn>
                          <TableColumn className='mqtquiz-score-table-td react-grid-Cell__value' 
                          style={{paddingRight:"0px"}}>{choice.question_start_time}</TableColumn>
                          <TableColumn className='mqtquiz-score-table-td react-grid-Cell__value' 
                          style={{paddingRight:"0px"}}>{choice.question_end_time}</TableColumn>
                          {/* <TableColumn className='mqtquiz-score-table-td react-grid-Cell__value' 
                          style={{paddingRight:"0px"}}>
                            {
                              (userCompletionDateHashMap !== null && userCompletionDateHashMap[choice.userID] !== null)
                              ?
                                userCompletionDateHashMap[choice.userID]
                              :
                              ''
                            }</TableColumn> */}
                          {
                            Object.values(answers).map((answerchoices,i)=>{
                              return <TableColumn key={i} className='mqtquiz-score-table-td react-grid-Cell__value'>{
                                answer_header?
                                answerchoices.map(val=>{
                                  return parseInt(val.charAt(0),10);
                                }).join()
                                :answerchoices.map(val=>{return parseInt(val,10)}).join()
                              }</TableColumn>
                            })
                          }
                        </TableRow>
              })}
            </TableBody>
          </DataTable>
        </div>
      };

const NonGradeTableColumns = [
  { key: "quizName", name: "Assignment Name", editable: false },
  { key: "userID", name: "User ID", editable: false },
  { key: "OSUID", name: "ID", editable: false },
  { key: "completionDate", name: "Completion Date", editable: false },
  { key: "questionText", name: "Question Text", editable: false },
  { key: "answerText", name: "Answer Text", editable: false ,formatter:AnswerTextFormatter} 
];




const ErrorIcon = () => <FontIcon style={{color:"red"}} >error</FontIcon>;
const SuccessIcon = () => <FontIcon style={{color:"green"}} >check</FontIcon>;

const GeneratingReportLoader = ({value,status}) => {
  
  return <div>
            <div className="consolidated-report-progress-container">
                <div className="md-display-1">Please wait. This operation will take several minutes to complete.</div>
                <LinearProgress value={value} determinate style={{ height: 10 ,width:"95%"}}  />
                <List className="md-paper md-paper--1 consolidated-report-progress-container-list-container">
                    <ListItem primaryText="Your report is being generated!"  />
                    {
                      status.map(stat=>{
                      return <ListItem primaryText={stat.quizName} rightIcon={stat.status === 1 ?<SuccessIcon />:stat.status === -1 ?<ErrorIcon/>:null} />
                      })
                    }
                </List>
            </div>
            
         </div>

}

let userCompletionDateHashMap = {}
let userInitiationDateHashMap = {}
let NonGradedAnswersTable = 
function(props){
  let {nonGradedQuestions,nonGradedMQTQuestions,createConsolidatedReport, generatingQuizReports, reportGenerationProgress, reportGenerationStatus, questionArray, answerArray, questions} = props;
  const appProperties = AppProperties();
  let hasNonGradedQuestions = false;
  let downloadRegularCSV
  if(nonGradedQuestions){
    hasNonGradedQuestions = true;
  }    
//console.debug(nonGradedQuestions,nonGradedMQTQuestions)

/* construct non graded Questions header */
  let nonGradedHeaders =[];

  let tempAnswerKeys = [];
  let tempAnswerTypes = [];
  if(questionArray && Object.keys(questionArray).length && answerArray && Object.keys(answerArray).length){
    for(let[q_key,q_value] of Object.entries(questionArray)) {
       for(let[a_key,a_value] of Object.entries(answerArray)){
         if(a_key.includes(q_key)){
           if(q_value.answer_type === 1){
            let tempAnswer = a_value.text.replace(/<[^>]+>/g,'');
            //   console.log('TempAnser', a_value.text)
              tempAnswerKeys.push(a_key)
              tempAnswerTypes.push(q_value.answer_type)
              nonGradedHeaders.push({key: a_key, label:`${q_value.category_name} - ${q_value.subcategory_name} - ${q_value.text} - ${tempAnswer}`})
           }
         }
       }
   }
  }
  if (questionArray && Object.keys(questionArray).length && questions) {
    for (let i = 0; i < questions?.length; i++) {
      let questionKey = questions[i];
      let questionObj = questionArray[questionKey];
      if (questionObj && questionObj.answer_type !== 1 && questionObj.question_type !== 2) {
        tempAnswerKeys.push(questionKey)
        tempAnswerTypes.push(questionObj.answer_type)
        nonGradedHeaders.push({key: questionKey, label:`${questionObj.category_name} - ${questionObj.subcategory_name} - ${questionObj.text}`, questionType: questionObj.question_type})
      }
   }
  }
  

  /* Fetch student answered checkbox id by id asc order*/
  let uniqueUserID = [];
  let finalNonGradedQuestions = [];

  function cleanHTML(htmlString) {
    // return htmlString;
    // Create a new DOMParser instance
    const parser = new DOMParser();
    // Parse the HTML string into a document
    const doc = parser.parseFromString(htmlString, 'text/html');
    // Use textContent to get the cleaned text
    return doc.body.textContent || "";
}

  if(nonGradedQuestions && nonGradedQuestions.length){
    let TempNonGradedQuestions = [...nonGradedQuestions];
    hasNonGradedQuestions && TempNonGradedQuestions && TempNonGradedQuestions.map((nonGradeData) => {
      if(uniqueUserID.includes(nonGradeData.userID)){
        let index = uniqueUserID.indexOf(nonGradeData.userID);
        let answeredArray =  [];
        let answerType = [];
        let textAnsArray = [];
        let previewAnsArray = [];
        let answerIDTemp = [];
        if (nonGradeData.questionType === 0 && nonGradeData.answerType === 2) {
          let val = nonGradeData.answerText;
          textAnsArray.push(val.replace(/"/g, '""'));
          answeredArray.push(`${nonGradeData.unique_id}`);
          answerType.push(nonGradeData.answerType);
          answerIDTemp.push(`${val}`)
          previewAnsArray.push('');
        } else {
          nonGradeData.answerID && nonGradeData.answerID.split(',').map(value => {
            answerType.push(nonGradeData.answerType);
            if(nonGradeData.answerType === 1){
             
              textAnsArray.push(nonGradeData.answerText);
              answeredArray.push(`${nonGradeData.unique_id}_${value}`);
              answerIDTemp.push(`${value}`)
            }else{
              
              answeredArray.push(`${nonGradeData.unique_id}`);
              if (nonGradeData.questionType === 4) {
                textAnsArray.push(nonGradeData.answerText);
                previewAnsArray.push(cleanHTML(nonGradeData.previewText));
              } else {
                textAnsArray.push(nonGradeData.answerText);
                previewAnsArray.push('');
              }
              answerIDTemp.push(`${value}`)
            }
          });
        }
        finalNonGradedQuestions[index]['answeredArray'] = [...finalNonGradedQuestions[index]['answeredArray'], ...answeredArray] 
        finalNonGradedQuestions[index]['answerType'] = [...finalNonGradedQuestions[index]['answerType'], ...answerType] 
        finalNonGradedQuestions[index]['textAnsArray'] = [...finalNonGradedQuestions[index]['textAnsArray'], ...textAnsArray]
        finalNonGradedQuestions[index]['previewAnsArray'] = [...finalNonGradedQuestions[index]['previewAnsArray'], ...previewAnsArray]
        finalNonGradedQuestions[index]['answerIDTemp'] = [...finalNonGradedQuestions[index]['answerIDTemp'], ...answerIDTemp]  
        //finalNonGradedQuestions[index] = {...finalNonGradedQuestions[index], ...tempArry}
      }else{
        uniqueUserID.push(nonGradeData.userID);
        let tempArry = {} ;
        tempArry['answeredArray'] = [];
        tempArry['answerType'] = [];
        tempArry['textAnsArray'] = [];
        tempArry['previewAnsArray'] = [];
        tempArry['answerIDTemp'] = [];
        if (nonGradeData.questionType === 0 && nonGradeData.answerType === 2) {
          let val = nonGradeData.answerText;
          tempArry['textAnsArray'].push(val.replace(/"/g, '""'));
          tempArry['answeredArray'].push(`${nonGradeData.unique_id}`);
          tempArry['answerType'].push(nonGradeData.answerType);
          tempArry['answerIDTemp'].push(`${val}`)
          tempArry['previewAnsArray'].push('');
        } else {
          nonGradeData.answerID && nonGradeData.answerID.split(',').map(value => {
            tempArry['answerType'].push(nonGradeData.answerType);
            if(nonGradeData.answerType === 1){
              tempArry['answeredArray'].push(`${nonGradeData.unique_id}_${value}`);
              tempArry['textAnsArray'].push(nonGradeData.answerText);
              tempArry['answerIDTemp'].push(`${value}`);
            }else{
              tempArry['answeredArray'].push(`${nonGradeData.unique_id}`);
              if (nonGradeData.questionType === 4) {
                tempArry['textAnsArray'].push(nonGradeData.answerText);
                tempArry['previewAnsArray'].push(cleanHTML(nonGradeData.previewText)); 
              } else {
                tempArry['textAnsArray'].push(nonGradeData.answerText); 
                tempArry['previewAnsArray'].push(''); 
              }
              tempArry['answerIDTemp'].push(`${value}`); 
            }
          });
        }
          finalNonGradedQuestions[finalNonGradedQuestions.length] = {...nonGradeData, ...tempArry}
      }
    });
    
  }
  
  /* Assing 0 and 1 for answered and non ansered check boxes */
  finalNonGradedQuestions.length && finalNonGradedQuestions.map(mainData => {
    console.debug("mainData", mainData)
    mainData['answerStatus'] = {};
    mainData['answerAscOrderStatus'] = [];
    
    tempAnswerKeys.length && tempAnswerKeys.map((header_key, hindex) => {
      
      if(tempAnswerTypes[hindex] === 1) {
        if((mainData.answeredArray.some(key => key === header_key))){
          mainData['answerAscOrderStatus'].push(1);
          mainData['answerStatus'][header_key] = 1;
        }else{
          mainData['answerAscOrderStatus'].push(0);
          mainData['answerStatus'][header_key] = 0;
        }
      }else if(tempAnswerTypes[hindex] === 2){
        let textIndex;
        if((mainData.answeredArray.some((key, i)=> { 
          textIndex = i;
          return header_key.includes(key)} ))){
            mainData['answerAscOrderStatus'].push(mainData.textAnsArray[textIndex]);
            mainData['answerStatus'][header_key] = mainData.textAnsArray[textIndex];
            if (mainData.questionType === 4) { // RC question ty[e]
              mainData['answerStatus'][header_key+"_preview"] = mainData.previewAnsArray[textIndex];
            }
          }
      }else{
        let textIndex = 0;
        if((mainData.answeredArray.some((key,i)=> { 
          textIndex = i;
          return header_key === key; }))){
            if(mainData.answeredArray.length === 1){
              textIndex = 0
            }
            let uniqKey = `${header_key}_${mainData.answerIDTemp[textIndex]}`
            mainData['answerAscOrderStatus'].push(answerArray[uniqKey].order);
            mainData['answerStatus'][header_key] = answerArray[uniqKey].order;
            if (mainData.questionType === 4) { // RC question ty[e
              mainData['answerStatus'][header_key+"_preview"] = answerArray[uniqKey].order;
            }
          }
      }
    })
  });


  let rowGetter = (index) =>{
    if(hasNonGradedQuestions){
     //console.debug(" nonGradedQuestions[index] ", nonGradedQuestions[index])
      return nonGradedQuestions[index];
    }   
    
    return -1;
  }

  let rowLength = 0;
  if(hasNonGradedQuestions){
    rowLength =   finalNonGradedQuestions.length;
  }

  var nonGradedQuestionsHeaders = [
    { label: 'Assignment Name', key: 'quizName' },
    { label: 'Student ID', key: 'userID' },
    // { label: 'ID', key: 'OSUID' },
    { label: 'SF ID', key: 'SFID' },
    { label: 'Section Name', key: 'section_name' },
    { label: 'Subsection Name', key: 'subsection_name' },
    { label: 'Start Date', key: 'initiationDate' },
    { label: 'Completion Date', key: 'completionDate' },
    // { label: 'Question Text', key: 'questionText' },
    // { label: 'Answer Text', key: 'answerText' },
  ];
  nonGradedHeaders.map((non_question) => {
    nonGradedQuestionsHeaders.push({label:non_question.label, key: non_question.key})
    if (non_question.questionType === 4) {
      nonGradedQuestionsHeaders.push({label:non_question.label + " Preview", key: non_question.key+'_preview'})
    }
  })


  if(hasNonGradedQuestions && finalNonGradedQuestions.length){
    let csvNonGradedQuestions = [...finalNonGradedQuestions]
    csvNonGradedQuestions.forEach((question,i) =>{
      let content   =  question.answerText.replace(/<[^>]+>/g, '');
      csvNonGradedQuestions[i].quizName = props.quizName
      csvNonGradedQuestions[i].answerText = content
      // csvNonGradedQuestions[i].OSUID = question.OSUID
      csvNonGradedQuestions[i].SFID= question.SFID
      csvNonGradedQuestions[i].section_name = question.section_name
      csvNonGradedQuestions[i].subsection_name = question.subsection_name
      if(userCompletionDateHashMap !== null && userCompletionDateHashMap[question.userID] !== null){
        csvNonGradedQuestions[i].completionDate = userCompletionDateHashMap[question.userID]
      }else{
        csvNonGradedQuestions[i].completionDate = ""
      }
      if(userInitiationDateHashMap !== null && userInitiationDateHashMap[question.userID] !== null){
        csvNonGradedQuestions[i].initiationDate = userInitiationDateHashMap[question.userID]
      }else{
        csvNonGradedQuestions[i].initiationDate = ""
      }
      for(let[c_key, c_value] of Object.entries(question.answerStatus)){
        csvNonGradedQuestions[i][c_key] =  c_value
      }
      // console.debug("question.answerStatus>>>", question.answerStatus, csvNonGradedQuestions)
      /* for(let[c_key, c_value] of Object.entries(question.answerStatus)){
        console.debug("csvNonGradedQuestions[i]", c_key, c_value, csvNonGradedQuestions[i])
        csvNonGradedQuestions[i][c_key+'_preview'] =  question.answerText.toString().replace(/(<([^>]+)>)/ig, "")
      } */
    })

    console.debug("csvNonGradedQuestions", csvNonGradedQuestions, nonGradedQuestionsHeaders)

    // "Question", "Code", "Category", "Text"
    let reasoningChainMappingHeaders = [
      {label:"Question", key:"question"},
      {label:"Code", key:"code"},
      {label:"Category", key:"category"},
      {label:"Text", key:"text"},
    ]
    let reasoningChainMappingValues = [];

    let reasoningChainLogHeaders = [
      {label:"Quiz ID", key:"quizID"},
      {label:"User ID", key:"userID"},
      {label:"Question ID", key:"questionID"},
      {label:"Log Time", key:"log_time"},
      {label:"Log", key:"log"},
    ]
    let reasoningChainLogValues = [];

    console.debug("nonGradedQuestions>>>>", nonGradedQuestions, props)
    let rcUniqueMap = {};

    nonGradedQuestions.forEach((nonGradedQuestion, nonGraQuesIndex) => {
      let rcUniquekey = `${nonGradedQuestion.unique_id}`

      if (nonGraQuesIndex === 0) {
        if (nonGradedQuestion.rc_logs && nonGradedQuestion.rc_logs.length) {
          nonGradedQuestion.rc_logs.forEach(rc_log => {
              reasoningChainLogValues.push({
                quizID: props.quizID,
                userID: rc_log.performedBy,
                questionID: rc_log.questionID,
                log_time: rc_log.formattedTime,
                log: rc_log.log,
              })
          })
        }
      }

        function formatString(input) {
          const elements = input.split(';');
          const result = [];
          for (let i = 0; i < elements.length; i += 2) {
              if (i + 1 < elements.length) {
                  result.push(`${elements[i]};${elements[i + 1]}`);
              } else {
                  result.push(elements[i]);
              }
          }
          return result
      }

      function replaceImagesWithAltText(mainText, altTextArr) {
        let index = 0;
        const parser = new DOMParser();
        const doc = parser.parseFromString(mainText, 'text/html');
        
        doc.querySelectorAll('img').forEach(img => {
          if (index < altTextArr.length) {
            const altText = altTextArr[index];
            const altSpan = doc.createElement('span');
            altSpan.textContent = `[${altText}]`;
            img.parentNode.replaceChild(altSpan, img);
            index++;
          }
        });
        
        return doc.body.innerHTML;
      }

      if (!rcUniqueMap.hasOwnProperty(rcUniquekey)) {

        rcUniqueMap[rcUniquekey] = "Added";

        if (nonGradedQuestion.questionType === 4) {
          if (nonGradedQuestion.reasoningChainElements && nonGradedQuestion.reasoningChainElements.length) {
            nonGradedQuestion.reasoningChainElements.forEach((ele, index) => {
              let mainText = ele.element;
              // console.debug("mainText BEFORE", mainText, ele)
              if (mainText.includes("<img")) {
                let altTextArr = formatString(ele.altText);
                mainText = replaceImagesWithAltText(mainText, altTextArr);
              }
              // console.debug("mainText AFTER", mainText)
              var editorState = TextEditor.createValueFromString(mainText);
              var plainText = editorState.getCurrentContent().getPlainText('\u0001')
              reasoningChainMappingValues.push({
                question: nonGradedQuestion.questionText,
                code: `R${index}`,
                category: ele.category,
                text: plainText
              })
            })
          }
          if (nonGradedQuestion.reasoningChainConnectingWords && nonGradedQuestion.reasoningChainConnectingWords.length) {
            nonGradedQuestion.reasoningChainConnectingWords.forEach((connectingWord, index) => {
              reasoningChainMappingValues.push({
                question: nonGradedQuestion.questionText,
                code: `J${index}`,
                category: "Connecting Word",
                text: connectingWord.word,
              })
            })
          }
    
          if (nonGradedQuestion.reasoningChainConclusionSentences && nonGradedQuestion.reasoningChainConclusionSentences.length) {
            nonGradedQuestion.reasoningChainConclusionSentences.forEach((ele, index) => {

              let mainText = ele.sentence;
              console.debug("mainText BEFORE", mainText, ele)
              
              if (mainText.includes("<img")) {
                let altTextArr = formatString(ele.altText);
                mainText = replaceImagesWithAltText(mainText, altTextArr);
              }

              console.debug("mainText AFTER", mainText)
              var editorState = TextEditor.createValueFromString(mainText);
              var plainText = editorState.getCurrentContent().getPlainText('\u0001')
              reasoningChainMappingValues.push({
                question: nonGradedQuestion.questionText,
                code: `C${index}`,
                category: "Conclusion Sentence",
                text: plainText
              })
            })  
          }
          
        }
        
      }
     
    })

    console.debug("csvNonGradedQuestions>>>>", csvNonGradedQuestions)
    let currentTime = Moment.tz(Date(), appProperties.currentUserData.timeZone || "America/New_York");
    downloadRegularCSV = (
      <div  style={{textAlign: "right"}}>
        <CSVLink
        id="csv-download-link-non-graded"
          data={csvNonGradedQuestions}
          headers={nonGradedQuestionsHeaders}
          filename={
          /* this.props.location.query.qname +
            '_' +
            this.props.location.query.course_name +*/
            'NonGradedAnswers-Regular Questions'+
            '_' +
            currentTime.format()+
            '.csv'
          }
        >
          {
            <Button primary swapTheming raised className="buttonColour">
              Download CSV
            </Button>
          }
        </CSVLink>
        <CSVLink
          id="csv-download-link-non-graded-mapping"
            data={reasoningChainMappingValues}
            headers={reasoningChainMappingHeaders}
            filename={
            /* this.props.location.query.qname +
              '_' +
              this.props.location.query.course_name +*/
              'NonGradedAnswers-Reasoning Chain Questions Mappping'+
              '_' +
              currentTime.format()+
              '.csv'
            }
          >
            {
              <Button primary swapTheming raised className="buttonColour" style={{marginLeft:'6px'}}>
                Download Reasoning Chain mapping
              </Button>
            }
        </CSVLink>
        <CSVLink
          id="csv-download-link-non-graded-rclogs"
            data={reasoningChainLogValues}
            headers={reasoningChainLogHeaders}
            filename={
            /* this.props.location.query.qname +
              '_' +
              this.props.location.query.course_name +*/
              'NonGradedAnswers-Reasoning Chain Activity Logs'+
              '_' +
              currentTime.format()+
              '.csv'
            }
          >
            {
              <Button primary swapTheming raised className="buttonColour" style={{marginLeft:'6px'}}>
                Download Reasoning Chain Activity Log
              </Button>
            }
        </CSVLink>
        </div>
    );  
  }

  if (generatingQuizReports) {
    return <GeneratingReportLoader value={reportGenerationProgress} status={reportGenerationStatus}/>
  }
  console.debug("finalNonGradedQuestions>>>", finalNonGradedQuestions);
  
  let tbody = (
    <tbody id="raw-data-table">
      {!hasNonGradedQuestions ?
       <tr><td colSpan={4} style={{textAlign:'center'}}>No Data</td></tr> 
        :
        finalNonGradedQuestions.map((data, index) => (
          <tr key={index}>
               <td style = {{maxWidth:"200px"}} >{data.quizName}</td>
               <td style = {{maxWidth:"200px"}} >{data.userID}</td>
               {/* <td style = {{maxWidth:"200px"}} >{data.OSUID}</td> */}
               <td style = {{maxWidth:"200px"}} >{data.SFID}</td>
               <td style = {{maxWidth:"200px"}} >{data.initiationDate}</td>
               <td style = {{maxWidth:"200px"}} >{data.completionDate}</td>
               {data.textAnsArray.map((text, index) =>(
                <>
                  <td style = {{maxWidth:"200px"}} key={index} >{text.toString().replace(/(<([^>]+)>)/ig, "")}</td>
                  {data.previewAnsArray[index] && data.previewAnsArray[index] !== '' ? 
                    <td style = {{maxWidth:"200px"}} key={index} >
                      <MathJax math={data.previewAnsArray[index]} />
                    </td>
                  : null}
                </>
               ))}
              {/*  {data.questionType === 4 ? 
                 <td style = {{maxWidth:"200px"}} key={index} >{data.previewText.toString().replace(/(<([^>]+)>)/ig, "")}</td>
               : null} */}
          </tr>
        ))
       }
    </tbody>
  )
  return [
        <div key='mqt-nongraded-questions'>
          
          <p styel={{fontSize:"medium"}} className='md-title md-title--toolbar'>Multiple choice questions 
          <Button id="download-non-graded-question" primary swapTheming raised className="buttonColour download-all-csv-button" onClick={createConsolidatedReport}>
              Download All CSV
            </Button></p>
          {Object.keys(nonGradedMQTQuestions).map((mqtQuestionKey,i) => {
            return (
              <MQTTable key={i} 
                mqtQuestion={nonGradedMQTQuestions[mqtQuestionKey]}
                quizName={props.quizName}
              />
            )
          })}
         
        </div>,
         <div key='nongraded-questions'>
              <p id={rowLength == 0 ? "no-data-in-table-non-graded":"data-present-non-graded"} styel={{fontSize:"medium"}}className='md-title md-title--toolbar'>
                Regular Questions
              </p>
          <div className="row">
          <span
            style={{ float: 'right', display: 'flex', marginRight: '30px' }}
          >
            
            <span>{downloadRegularCSV}</span>
          </span>
        </div>
            {/* <br/>
          <ReactDataGrid
            enableCellSelect={false}
            //columns={NonGradeTableColumns}
            columns={nonGradedHeaders}
            rowGetter={rowGetter}
            rowsCount={rowLength}
            headerRowHeight={45}
            rowHeight={30}
            minHeight={900}
          /> */}
          <div className="rawDataTableContainer">
          <table style={styles.quizScoreTableNonGraded} className="rawDataTable">
            <thead style={styles.thead}>
              <tr>
              <th>Assignment Name</th>
              <th>User ID</th>
              {/* <th>ID</th> */}
              <th>SF ID</th>
              <th>Start Date</th>
              <th>Completion Date</th>
                {nonGradedHeaders.map((data, index) => {
                  if (data.questionType === 4) {
                    return (
                      <>
                        <th key={data.key} style = {{maxWidth:"300px"}}>{data.label}</th>
                        <th key={data.key+"_preview"} style = {{maxWidth:"300px"}}>{data.label} Preview</th>
                      </>
                     )
                  }
                  return <th key={data.key} style = {{maxWidth:"300px"}}>{data.label}</th>;
                 
                })}
                {/* {nonGradedHeaders.map((data, index) => {
                 return <th key={data.key} style = {{maxWidth:"300px"}}>{data.label} (Preview)</th>
                })} */}
              </tr>
            </thead>
            {tbody}
          </table>
          </div>
        </div>
        ]
}


const labelFunctionCat = function(catName,columnName) {
  return "<"+catName+"> - ("+columnName+")";
};

const labelFunctionSubCat = function(catName,subCatName,columnName) {
  //<Cat full Name> ---><SC full name> -  (Questions Correct)

  return "<"+catName+">  ---> <"+subCatName+"> - ("+columnName+")";
};



export default class QuizScore extends Component {
  appProperties = AppProperties();
  constructor(props) {
    super(props);
    this.state = {
      quiz_scores: [],
      visible: false,
      class_name: this.props.location.query.class,
      quiz_name: this.props.location.query.qname,
      static: this.props.location.query.static,
      quiz_id: this.props.location.query.quiz_id,
      course_id:this.props.location.query.course_id,
      section_id:this.props.location.query.section_id,
      is_anonymous:this.props.location.query.is_anonymous,
      quizData:[],
      categoryNamesArr: [],
      nonGradedMQTQuestions:[],
      nonGradedQuestions:[],
      showDialog:false,
      generatingQuizReports:false,
      reportGenerationProgress:0,
      reportGenerationStatus:[],
      loading:true,
      noDataFlag:false, ////noDataFlag used to Denote that there is no data, which will be used when creating conslidated report
      question_arr: [],
      answer_arr:[],
      questions:[] // array of question keys, key = subjectID_topicID_categoryID_subcategoryID_questionID
    };

    this.catStatistics = [];
    this.catDetailsCSV = [];
  }

  //Code to Get Archive Data
  getQuizViewScoreArchiveData = async(semesterID,courseID,sectionID,quizID)=> {

    try{
        let getQuizViewScoreDataResp = await ApiRequestService({
            method: 'post',
            url:'archivedQuizViewScore',
            data: { semesterID:semesterID,
                courseID:courseID,
                sectionID:sectionID,
            quizID:quizID}
        })
        if(getQuizViewScoreDataResp.data !== undefined && getQuizViewScoreDataResp.data !== null){
            if(getQuizViewScoreDataResp.data.status === 0 && getQuizViewScoreDataResp.data.data !== undefined && getQuizViewScoreDataResp.data.data !== null){

              this.processQuizData(JSON.parse(getQuizViewScoreDataResp.data.data));

            }else if (getQuizViewScoreDataResp.data.message !== undefined &&  getQuizViewScoreDataResp.data.message !== null ) {
                NotificationManager.error(getQuizViewScoreDataResp.data.message,"Error",5000);
            }else{
                NotificationManager.error("Archive failed with Unknown Server Error","Error",5000);
            }
        }else{
            NotificationManager.error("Archive failed with Unknown Server Error","Error",5000);
        }
    }catch(err){

        NotificationManager.error(err,"Error",5000);
    }finally{
        this.setState({loadingCourse:false});
    }
}
  componentWillUpdate() {
    this.addBreadCrumbs();
  }

  componentWillUnmount() {
    this.removeBreadCrumbs();
  }
  addBreadCrumbs = () => {
    this.props.replaceBreadCrumb([
      { 
        name: this.props.location.query.course_name, 
        type: '', 
        onclickPath: 'CoursesDashboard?course_indx=' + this.props.location.query.course_indx
      }
    ]);
  };
  removeBreadCrumbs = () => {
    this.props.replaceBreadCrumb([]); 
  };

  componentWillMount() {
    console.log("this.state.archiveMode",this.state.archiveMode);

    if(this.props.location.query.archiveMode){
      let semesterID = parseInt(this.props.location.query.semesterID,10);
      let courseID = parseInt(this.props.location.query.courseID,10);
      let sectionID = parseInt(this.props.location.query.sectionID,10);
      let quizID = parseInt(this.props.location.query.quizID,10);
      this.getQuizViewScoreArchiveData(semesterID,courseID,sectionID,quizID);
    }else{
    const payload = {
      quiz_name: this.state.quiz_name,
      class_name: this.state.class_name,
      static: 1, //parseInt(this.state.static, 10)
      quiz_id:parseInt(this.state.quiz_id, 10),
      course_id:parseInt(this.state.course_id, 10),
      section_id:parseInt(this.state.section_id, 10)
    };
    console.debug('Quiz Score req : ', payload);

    ApiRequestService({
      method: 'post',
      //url: '/getQuizScore',
      url: '/getQuizScore',
      data: payload
    }).then(res =>{
      if(res && res.data && res.data.data)
        this.processQuizData(res.data.data);
    } );

}
}

processQuizData = (data) => {
  console.log('getQuizScore data :', data);
  var tempCategoryNamesArr =[];
  let isQuizEmpty = false;

  this.catStatsColumns = this.buildCatStatsColumns(data.columnsArray);
  this.columnsArray = data.columnsArray;

  this.catStatistics =data.subCateQuizStats;

  this.expStatCols = this.buildExplanationColumns(data.explanation_columns);
  this.expColumnsArray = data.explanation_columns;

  this.student_explanation_elapsed_times = data.student_explanation_elapsed_times;


  if (data != null && data.quiz_scores != null) {

    var tempdataArr = [];
    for(var  i = 0; i < data.quiz_scores.length; i++){
     // tempdata[i] =  res.data.data.quiz_scores[i];
     //bug id 175
     var tempdata = data.quiz_scores[i];
     tempdata['user_id'] = data.quiz_scores[i]['UserName'];

      //var quizScore = (data.quiz_scores[i]['skill_mast']/data.quiz_scores[i]['skill_tot'])*100;
      tempdata['total_score'] = data.quiz_scores[i]['total_score'];

      tempdata['quiz_time'] =data.quiz_scores[i]['quiz_time'];

      let catStats = this.getCatStatsForUser(data.quiz_scores[i]['UserName'])

      let expStats = this.getExpStatsForUser(data.quiz_scores[i]['UserName'])
      tempdata["tableData"] = [...catStats.tableData,...expStats.tableData];
      let csvData = {...catStats.csvData,...expStats.csvData};

      tempdata = {...tempdata,...csvData};
      tempdataArr.push(tempdata);

      userCompletionDateHashMap[tempdata['user_id']] = data.quiz_scores[i]['completedDate'];
      let startTimeArr = data.quiz_scores[i]['startTime'];
      if (startTimeArr && startTimeArr.length) {
        userInitiationDateHashMap[tempdata['user_id']] = startTimeArr[0];
      } else {
        userInitiationDateHashMap[tempdata['user_id']] = "";
      }
      
    }



    this.setState({
      quizData : tempdataArr,
      categoryNamesArr: tempCategoryNamesArr,
      nonGradedQuestions:data.nonGradedQuestions,
      nonGradedMQTQuestions:data.nonGradedMQTQuestions,
      question_arr: data.questions_map,
      answer_arr:data.answers_map,
      questions: data.questions,
    });


  }else{
    isQuizEmpty = true;
  }
  //noDataFlag used to Denote that there is no data, which will be used when creating conslidated report
  this.setState({loading:false,noDataFlag:isQuizEmpty})
  window.scrollTo(0, 0)
}

buildCatStatsColumns = (columnsArray) =>{
  let catStatsColumns = [];
  let catStatsColumnsCSV = [];

  if(columnsArray !== undefined && columnsArray !== null){

    for (let catKey in columnsArray) {
      //<Cat Name > - (Questions Correct)
      catStatsColumns.push(<th key={catKey+".MC"}>{labelFunctionCat(catKey,"Mastery Count")}</th>);
      catStatsColumnsCSV.push({ label: labelFunctionCat(catKey,"Mastery Count"), key: catKey+".MC"});
      catStatsColumns.push(<th key={catKey+".AA"}>{labelFunctionCat(catKey," Avg Attempt")}</th>);
      catStatsColumnsCSV.push({ label: labelFunctionCat(catKey," Avg Attempt"), key: catKey+".AA"});
      catStatsColumns.push(<th key={catKey+".QC"}>{labelFunctionCat(catKey," Correct#")}</th>);
      catStatsColumnsCSV.push({ label: labelFunctionCat(catKey," Correct#"), key: catKey+".QC"});
      catStatsColumns.push(<th key={catKey+".QA"}>{labelFunctionCat(catKey," Attempted#")}</th>);
      catStatsColumnsCSV.push({ label: labelFunctionCat(catKey," Attempted#"), key: catKey+".QA"});
      catStatsColumns.push(<th key={catKey+".C"}>{labelFunctionCat(catKey," Correct % for first N= mastery count, first attempt taken")}</th>);
      catStatsColumnsCSV.push({ label:labelFunctionCat(catKey," Correct % for first N= mastery count, first attempt taken"), key: catKey+".CN"});
      catStatsColumns.push(<th key={catKey+".C"}>{labelFunctionCat(catKey," Correct %")}</th>);
      catStatsColumnsCSV.push({ label:labelFunctionCat(catKey," Correct %"), key: catKey+".C"});
      catStatsColumns.push(<th key={catKey+".TT"}>{labelFunctionCat(catKey," Time Taken")}</th>);
      catStatsColumnsCSV.push({ label: labelFunctionCat(catKey," Time Taken"), key: catKey+".TT"});
      catStatsColumns.push(<th key={catKey+".FTT"}>{labelFunctionCat(catKey," First Attempt Time Taken")}</th>);
      catStatsColumnsCSV.push({ label: labelFunctionCat(catKey," First Attempt Time Taken"), key: catKey+".FTT"});

      columnsArray[catKey].forEach(subCatKey => {
      catStatsColumns.push(
          <th key={subCatKey+catKey+".QC"}>{labelFunctionSubCat(catKey,subCatKey,"Correct#")}</th>);
          catStatsColumnsCSV.push({ label: labelFunctionSubCat(catKey,subCatKey,"Correct#"), key: subCatKey+catKey+".QC"});
          catStatsColumns.push(<th key={ subCatKey+catKey+".QA"}>{labelFunctionSubCat(catKey,subCatKey,"Attempted#")}</th>);
          catStatsColumnsCSV.push({ label: labelFunctionSubCat(catKey,subCatKey,"Attempted#"), key:subCatKey+catKey+".QA"});
          catStatsColumns.push(<th key={subCatKey+catKey+".C"}>{labelFunctionSubCat(catKey,subCatKey,"Correct%")}</th>);
          catStatsColumnsCSV.push({ label: labelFunctionSubCat(catKey,subCatKey,"Correct%"), key: subCatKey+catKey+".C"});
          catStatsColumns.push(<th key={subCatKey+catKey+".TT"}>{labelFunctionSubCat(catKey,subCatKey,"Time Taken") }</th>);
          catStatsColumnsCSV.push({ label: labelFunctionSubCat(catKey,subCatKey,"Time Taken") , key: subCatKey+catKey+".TT"});
          catStatsColumns.push(<th key={subCatKey+catKey+".FTT"}>{labelFunctionSubCat(catKey,subCatKey,"First Attempt Time Taken") }</th>);
          catStatsColumnsCSV.push({ label: labelFunctionSubCat(catKey,subCatKey,"First Attempt Time Taken") , key: subCatKey+catKey+".FTT"});

      });


    }

  }
  this.catStatsColumnsCSV = catStatsColumnsCSV;
  return catStatsColumns;
}

buildExplanationColumns = (columnsArray) =>{
  let explanationStatsCols = [];
  let explanationStatsColsCSV = [];

  if(columnsArray !== undefined && columnsArray !== null){
    console.log("columnsArray  ",columnsArray);
    columnsArray.forEach(catKey => {


    //for (var catKey in columnsArray) {

      //<Cat Name > - (Questions Correct)
      let expUniqueID = catKey.subject_id+ "_" + catKey.topic_id+ "_" + catKey.category_id+ "_" + catKey.subcategory_id+ "_" + catKey.explanation_id;
      explanationStatsCols.push(<th key={catKey.expUniqueID+".ET"}>{labelFunctionCat(catKey.explanation_name,"Elapsed Time")}</th>);
      explanationStatsColsCSV.push({ label: labelFunctionCat(catKey.explanation_name,"Elapsed Time"), key: expUniqueID+".ET"});

      //console.log(element);
    });

  }
  this.explanationStatsColsCSV = explanationStatsColsCSV;
  return explanationStatsCols;
}

getCatStatsForUser = (userID) => {

  let catStats = [];
  let csvData = {};

  if( this.columnsArray !== undefined && this.columnsArray !== null){
    let columnsArray = this.columnsArray;
    for (let catKey in columnsArray) {
      if(this.catStatistics[userID] !== undefined &&
        this.catStatistics[userID][catKey] !== undefined){
        catStats.push(<td key={catKey+"-"+userID+".MC"}>{this.catStatistics[userID][catKey].masteryCount}</td>);
        let avgAttempt = roundToX((this.catStatistics[userID][catKey].questionsAttempted /this.catStatistics[userID][catKey].masteryCount ),2);
        catStats.push(<td key={catKey+"-"+userID+".AA"}>{avgAttempt}</td>);
        catStats.push(<td key={catKey+"-"+userID+"-Correct#"}>{this.catStatistics[userID][catKey].questionsCorrect}</td>);
        catStats.push(<td key={catKey+"-"+userID+"-Attempted#"}>{this.catStatistics[userID][catKey].questionsAttempted}</td>);
        let correctPercent = roundToX(((this.catStatistics[userID][catKey].questionsCorrect/this.catStatistics[userID][catKey].questionsAttempted)*100),2);
        catStats.push(<td key={catKey+"-"+userID+"-CorrectN%"}>{this.catStatistics[userID][catKey].firstNPercentage}</td>);
        catStats.push(<td key={catKey+"-"+userID+"-Correct%"}>{correctPercent}</td>);
        catStats.push(<td key={catKey+"-"+userID+"-_TimeTaken"}>{this.catStatistics[userID][catKey].timeTaken}</td>);
        catStats.push(<td key={catKey+"-"+userID+"-_FirstTimeTaken"}>{this.catStatistics[userID][catKey].firstAttemptTimeTaken}</td>);

        csvData[catKey+".MC"] = this.catStatistics[userID][catKey].masteryCount;
        csvData[catKey+".AA"] = avgAttempt;
        csvData[catKey+".QC"] = this.catStatistics[userID][catKey].questionsCorrect;
        csvData[catKey+".QA"] = this.catStatistics[userID][catKey].questionsAttempted;
        csvData[catKey+".CN"] = this.catStatistics[userID][catKey].firstNPercentage;
        csvData[catKey+".C"] =correctPercent;
        csvData[catKey+".TT"] = this.catStatistics[userID][catKey].timeTaken;
        csvData[catKey+".FTT"] = this.catStatistics[userID][catKey].firstAttemptTimeTaken;

        columnsArray[catKey].forEach(subCatKey => {
          let subCatObj = this.catStatistics[userID][catKey].subCatStats[subCatKey];
          if(subCatObj !== undefined && subCatObj !== null ){
            catStats.push(<td key={subCatKey+"-"+userID+"-Correct#"}>{subCatObj.questionsCorrect}</td>);
            catStats.push(<td key={subCatKey+"-"+userID+"-Attempted#"}>{subCatObj.questionsAttempted}</td>);
            let correctPercent = roundToX(((subCatObj.questionsCorrect/subCatObj.questionsAttempted)*100),2);
            catStats.push(<td key={subCatKey+"-"+userID+"-Correct%"}>{correctPercent}</td>);
            catStats.push(<td key={subCatKey+"-"+userID+"-_TimeTaken#"}>{subCatObj.timeTaken}</td>);
            catStats.push(<td key={subCatKey+"-"+userID+"-_FirstTimeTaken#"}>{subCatObj.firstAttemptTimeTaken}</td>);

            csvData[subCatKey+catKey+".QC"] = subCatObj.questionsCorrect;
            csvData[subCatKey+catKey+".QA"] = subCatObj.questionsAttempted;
            csvData[subCatKey+catKey+".C"] = correctPercent;
            csvData[subCatKey+catKey+".TT"] = subCatObj.timeTaken;
            csvData[subCatKey+catKey+".FTT"] = subCatObj.firstAttemptTimeTaken;
          }else{
            catStats.push(<td key={subCatKey+"-"+userID+"-Correct#"}>n/a</td>);
            catStats.push(<td key={subCatKey+"-"+userID+"-Attempted#"}>n/a</td>);
            catStats.push(<td key={subCatKey+"-"+userID+"-Correct%"}>n/a</td>);
            catStats.push(<td key={subCatKey+"-"+userID+"-_TimeTaken#"}>n/a</td>);
            catStats.push(<td key={subCatKey+"-"+userID+"-_FirstTimeTaken#"}>n/a</td>);

            csvData[subCatKey+catKey+".QC"] = "n/a";
            csvData[subCatKey+catKey+".QA"] = "n/a";
            csvData[subCatKey+catKey+".C"] = "n/a";
            csvData[subCatKey+catKey+".TT"] = "n/a";
            csvData[subCatKey+catKey+".FTT"] = "n/a";
          }
        });
      }else{
        catStats.push(<td key={catKey+"-"+userID+".MC"}>n/a</td>);
        catStats.push(<td key={catKey+"-"+userID+".AA"}>n/a</td>);
        catStats.push(<td key={catKey+"-"+userID+"-Correct#"}>n/a</td>);
        catStats.push(<td key={catKey+"-"+userID+"-Attempted#"}>n/a</td>);
        catStats.push(<td key={catKey+"-"+userID+"-Correct%"}>n/a</td>);
        catStats.push(<td key={catKey+"-"+userID+"-_TimeTaken"}>n/a</td>);
        catStats.push(<td key={catKey+"-"+userID+"-_FirstTimeTaken"}>n/a</td>);

        csvData[catKey+".MC"] = "n/a";
        csvData[catKey+".AA"] = "n/a";
        csvData[catKey+".QC"] = "n/a";
        csvData[catKey+".QA"] = "n/a";
        csvData[catKey+".C"] = "n/a";
        csvData[catKey+".TT"] = "n/a";
        csvData[catKey+".FTT"] = "n/a";

        columnsArray[catKey].forEach(subCatKey => {
          catStats.push(<td key={subCatKey+"-"+userID+"-Correct#"}>n/a</td>);
          catStats.push(<td key={subCatKey+"-"+userID+"-Attempted#"}>n/a</td>);
          catStats.push(<td key={subCatKey+"-"+userID+"-Correct%"}>n/a</td>);
          catStats.push(<td key={subCatKey+"-"+userID+"-_TimeTaken#"}>n/a</td>);
          catStats.push(<td key={subCatKey+"-"+userID+"-_FirstTimeTaken#"}>n/a</td>);

          csvData[subCatKey+catKey+".QC"] = "n/a";
          csvData[subCatKey+catKey+".QA"] = "n/a";
          csvData[subCatKey+catKey+".C"] = "n/a";
          csvData[subCatKey+catKey+".TT"] = "n/a";
          csvData[subCatKey+catKey+".FTT"] = "n/a";

        });
      }



  }}



  return {"tableData":catStats,"csvData":csvData};
}

getExpStatsForUser = (userID) => {

    let expStats = [];
    let csvData = {};
   console.log("user ID ", userID)
    if( this.expColumnsArray !== undefined && this.expColumnsArray !== null){
      let expColumnsArray = this.expColumnsArray;
      console.log("elasped time  db:",this.student_explanation_elapsed_times)

      expColumnsArray.forEach(catKey => {
        let expUniqueID = catKey.subject_id+ "_" + catKey.topic_id+ "_" + catKey.category_id+ "_" + catKey.subcategory_id+ "_" + catKey.explanation_id;
        if(this.student_explanation_elapsed_times[userID] !== undefined &&
            this.student_explanation_elapsed_times[userID] !== null){
          let elapsedObj = this.student_explanation_elapsed_times[userID][expUniqueID];
          if(elapsedObj !== undefined && elapsedObj !== null){

            expStats.push(<td key={expUniqueID+"-"+userID+".ET"}>{elapsedObj.elapsed_time}</td>);

            csvData[expUniqueID+".ET"] = elapsedObj.elapsed_time;

            console.log("elasped time  ",elapsedObj.elapsed_time)
          }
          else{
            expStats.push(<td key={expUniqueID+"-"+userID+".ET"}>n/a</td>);

            csvData[expUniqueID+".ET"] = "n/a";

          }
        }
        else{
          expStats.push(<td key={expUniqueID+"-"+userID+".ET"}>n/a</td>);

          csvData[expUniqueID+".ET"] = "n/a";

        }
        });



    }



    return {"tableData":expStats,"csvData":csvData};
  }


onViewNonGradeClicked = () => {
  this.setState({showDialog:true});
}
//Hide Dialog
onDialogHide =  ()  => {
  this.setState({showDialog:false})
}

getReportBlobData = async(reportLink)=>{
  return new Promise(function(resolve, reject) {
    const timerID = setInterval(function() {
      if(reportLink){
        clearInterval(timerID);
        JSZipUtils.getBinaryContent(reportLink, function (err, data) {
          if(err) {
            reject(err); // or handle the error
          }
          resolve(data);
       });
      }
    },3000);
  });
};

/* consolidate the csv files and parse it into Zip Downloader*/
generateConsolidatedReport = async()=> {
  let completedQuizes = 0;
  
  return new Promise(async (resolve, reject)=>{
    let jsZip = JsZip();
    const sectionFileName = this.props.location.query.qname;
    let numberOfCSVLinks = document.querySelectorAll("#csv-download-link-popup");
    
    if(numberOfCSVLinks && numberOfCSVLinks != null && numberOfCSVLinks.length> 0) {
      //loop through CSVLinks
      for (let CSVindex = 0; CSVindex < numberOfCSVLinks.length; CSVindex++) {
       let quiz = {};
        try {
          const reportBlobData = await this.getReportBlobData(numberOfCSVLinks[CSVindex].href);
          jsZip.file(`${numberOfCSVLinks[CSVindex].download.replace(/[/\\?%*:|"<>]/g, '_')}`, reportBlobData, {binary:true});
          completedQuizes++;
          
          this.setState({
            reportGenerationProgress: ((completedQuizes / numberOfCSVLinks.length) * 100),
          });
        } catch(err) {
          console.log("Error", err);
        }      
      }
  
      jsZip.generateAsync({ type: "blob" }).then((zipFile) => {
        saveAs(zipFile, `${sectionFileName}_conslidated_.zip`)
      }).finally(()=>{
        resolve(true);
      });
  
    } else {
      // TODO show Error Message
      resolve(true);
    }
  });
  
}

createConsolidatedReport=()=>{
  //ToDo - Notify user that this could take a while

 this.setState({ generatingQuizReports:true ,reportGenerationProgress:0, reportGenerationStatus:[] });

  this.generateConsolidatedReport().finally(()=> {
    this.setState({generatingQuizReports: false});
  });

 }

render() {
  // let QuizSocreData1 = {QuizSocreData}
  // console.log("QuizSocreData =",QuizSocreData1);

  let downloadCSV = (
    <Button raised disabled>
      Download CSV
    </Button>
  );



  var tbody = (
    <tbody id="raw-data-table">
      {this.state.noDataFlag? 
        <tr><td>No Data</td></tr>
      :this.state.quizData.map((score, index)=> (
        <tr key={index}>
          {this.state.is_anonymous && JSON.parse(this.state.is_anonymous) ? null : <>
            <td>{score.first_name}</td>
            <td>{score.last_name}</td>
          </>}
          {/* <td>{score.OSUID}</td> */}
          <td>{score.userID}</td>
          <td>
            {this.state.is_anonymous && JSON.parse(this.state.is_anonymous) ? `Student ${index+1}` : score.UserName}
          </td>
          <td>{score.practice_count}</td>
          <td>{score.section_name}</td>
          <td>{score.subsection_name}</td>
          <td>{score.quiz_name}</td>
          <td>{score.ques_corr}</td>
          <td>{score.ques_att}</td>
          <td>{score.skill_mast}</td>
          <td>{score.skill_tot}</td>
          <td>{score.total_score}</td>
          <td>{score.quiz_time}</td>
          <td>{score.completedDate}</td>
          <td><pre>{score.startTime !== undefined &&
              score.startTime !== null &&
              score.startTime.length > 0 ?
              score.startTime.join('\n'):
              ''}</pre></td>
          <td><pre>{score.endTime !== undefined &&
              score.endTime !== null &&
              score.endTime.length > 0 ?
              score.endTime.join('\n'):
              ''}</pre></td>
            {score.tableData}
        </tr>
      ))}
    </tbody>
  );

  if (this.state.quizData.length > 0) {

    // {categoryNamesArr.map((categoryName) =>
    //   label: categoryName, key:  )}


    var headers = [
      { label: 'First Name', key: 'first_name' },
      { label: 'Last Name', key: 'last_name' },
      { label: 'SF ID', key: 'userID' },
      { label: 'Student ID', key: 'user_id' },
      { label: 'Practice Count', key: 'practice_count' },
      { label: 'Section Name', key: 'section_name' },
      { label: 'Subsection Name', key: 'subsection_name' },
      { label: 'Assignment Name', key: 'quiz_name' },
      { label: 'Questions Correct', key: 'ques_corr' },
      { label: 'Questions Attempted', key: 'ques_att' },
      { label: 'Skills Mastered', key: 'skill_mast' },
      { label: 'Total Skills', key: 'skill_tot' },
      { label: 'Score', key: 'total_score' },
      { label: 'AssignmentTime(sec)', key: 'quiz_time' },
      { label: 'Completed Date', key: 'completedDate' },
      { label: 'Start Time', key: 'startTime' },
      { label: 'End Time', key: 'endTime' },
      //{ label: 'Category Correct %', key: 'catCorrectpercentStr' },
    ];

    if (this.state.is_anonymous && JSON.parse(this.state.is_anonymous)) {
      headers = headers.filter(header => !['first_name', 'last_name'].includes(header.key))
      headers = headers.map(header => {
        if (header.key === 'user_id') {
          return {
            ...header,
            label: "Anon - ID"
          }
        }
        return header;
      })
    }

    headers = headers.concat(this.catStatsColumnsCSV);
    headers = headers.concat(this.explanationStatsColsCSV);

     //console.log("headers",headers,this.state.quizData,this.catDetailsCSV);
    let csvQuizData = this.state.quizData.concat(this.catDetailsCSV)
    
    if (this.state.is_anonymous && JSON.parse(this.state.is_anonymous)) {
      csvQuizData = csvQuizData.map((data, index) => {
        return {
          ...data,
          user_id: `Student ${index+1}`
        }
      })
    }

    console.debug("headers>>>", headers, csvQuizData);

    let currentTime = Moment.tz(Date(), this.appProperties.currentUserData.timeZone || "America/New_York");
    downloadCSV = (
      <div>
        <CSVLink
          id="csv-download-link"
          data={csvQuizData}
          headers={headers}
          filename={
            this.props.location.query.qname +
            '_' +
            this.props.location.query.course_name +
            '_' +
            currentTime.format()+
            '.csv'
          }
        >
          {
            <Button primary swapTheming raised className="buttonColour"  id="raw-data-csv-button">
              Download CSV
            </Button>
          }
        </CSVLink>
      </div>
    );
  }

  return (
    (this.state.loading) ?
     <LoadingSpinner loading={this.state.loading} />
    :
    <div>
      <div className="row" style={{ paddingLeft: '40px' }}>
        <span style={{ float: 'left', padding: '10px' }}>
          <h1>Assignment Results - {this.state.quiz_name}</h1>
        </span>
      </div>
      <div className="row">
        <span
          style={{ float: 'right', display: 'flex', marginRight: '30px', marginBottom: '10px' }}
        >

          <Button raised id="view-non-graded-answers" className="md-text--theme-primary" style={{marginRight:"10px"}} 
          onClick={this.onViewNonGradeClicked}>View Non-Graded Answers</Button>

          <span>{downloadCSV}</span>
        </span>
      </div>
      <div className="rawDataTableContainer">
      <table style={styles.quizScoreTable} className="rawDataTable">
        <thead style={styles.thead}>
          <tr>
            {this.state.is_anonymous && JSON.parse(this.state.is_anonymous) ? null : <>
              <th>First Name</th>
              <th>Last Name</th>
            </>}
            <th>SF ID</th>
            <th>
              {this.state.is_anonymous && JSON.parse(this.state.is_anonymous) ? "Anon - ID" : "Student ID"}
            </th>
            <th>Practice Count</th>
            <th>Section Name</th>
            <th>Subsection Name</th>
            <th>Assignment Name</th>
            <th>Questions Correct</th>
            <th>Questions Attempted</th>
            <th>Skills Mastered</th>
            <th>Total Skills</th>
            <th>Score</th>
            <th>AssignmentTime(sec)</th>
            <th>Completion Date</th>
            <th>Start Time(s)</th>
            <th>End Time(s)</th>

            {this.catStatsColumns}

            {this.expStatCols}

          </tr>
        </thead>

        {tbody}
      </table></div>
      
      <DialogContainer
        fullPage
        id="nonGradedQuestions"
        visible={this.state.showDialog}
        onHide={this.onDialogHide}
        aria-describedby="gradebook-popup"
        focusOnMount={false}
        >
        <Toolbar
            title="Non Graded Questions"
            actions={<Button  flat onClick={this.onDialogHide}>Close</Button>}
          />

        <NonGradedAnswersTable 
          key='NonGradedAnswersTable' 
          nonGradedMQTQuestions={this.state.nonGradedMQTQuestions}
          createConsolidatedReport={this.createConsolidatedReport} 
          nonGradedQuestions={this.state.nonGradedQuestions} 
          quizName={this.props.location.query.qname}
          generatingQuizReports={this.state.generatingQuizReports}
          reportGenerationProgress={this.state.reportGenerationProgress}
          reportGenerationStatus={this.state.reportGenerationStatus}
          questionArray={this.state.question_arr}
          answerArray ={this.state.answer_arr}
          questions={this.state.questions}
          quizID={this.state.quiz_id}
          id='nonGradedQuestions-popup'>
          </NonGradedAnswersTable>

    </DialogContainer>
    </div>
  );
}
}
